/**
 * システム管理API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SlideTankaMasterDto { 
    /**
     * 調整単価コード：数字<br>　画面項目ID＝\'C001300\'
     */
    choseiTankaCode?: string;
    /**
     * 調整単価コード（名称）：全角
     */
    choseiTankaCodeAname?: string;
    /**
     * 計算年月(年)：数字
     */
    calcYmt?: string;
    /**
     * 適用開始日付：日付(yyyyMMdd)
     */
    applyStartDate?: string;
    /**
     * 適用終了日付：日付(yyyyMMdd)
     */
    applyEndDate?: string;
    /**
     * 更新通番号：数字
     */
    updateSrno?: string;
    /**
     * 調整単価：数字
     */
    choseiTanka?: number;
}

